export const EXPORT_EXCEL_TYPE_DONNEES_MARCHES = 'marche';
export const TYPE_EXPORT_EXCEL_MARCHES = '';
